// Instead of writing this in Kotlin & Swift, I write the AST
// in this file and pass it through to Capacitor for rendering

import { CapNotificationAllowedTags } from "./cap-notification-allowed-tags"

type AllowedTag = (typeof CapNotificationAllowedTags)[number]
function isAllowedTag(tag: string): tag is AllowedTag {
    return CapNotificationAllowedTags.includes(tag as (typeof CapNotificationAllowedTags)[number])
}

export type MockNode = MockTextNode | MockHTMLNode

export class MockTextNode {
    type = "text" as const
    constructor(public readonly text: string) {}
}

export class MockHTMLNode {
    type = "element" as const
    constructor(
        public readonly name: (typeof CapNotificationAllowedTags)[number],
        public readonly children: MockNode[],
    ) {}
}

export function parseMockHTMLAST(html: string): MockNode[] {
    const ele = document.createElement("div")
    ele.innerHTML = html
    return parseNodeList(ele.childNodes)
}

function parseNodeList(childNodes: Iterable<Node>): MockNode[] {
    const children = [...childNodes]
        .map((node) => parseNode(node))
        .flatMap((node) => (node !== null ? [node] : [])) //TypeScript trick because `filter` doesn't carry types
    return children
}

function parseNode(node: Node): MockNode | null {
    if (node instanceof Text) {
        const content = node.textContent
        if (!content || content.trim() === "") return null
        return new MockTextNode(content)
    } else if (node instanceof Element) {
        const tag = node.tagName
        if (!isAllowedTag(tag))
            throw new Error(`Tag ${tag} is not allowed and cannot be parsed by native design views`)
        return new MockHTMLNode(tag, parseNodeList(node.childNodes))
    } else {
        console.error(node)
        throw new Error(`Unrecognized node to send to parse Mock HTML`)
    }
}

export function stripHtml(html : string) : string {
    const ele = document.createElement("div")
    ele.innerHTML = html
    return ele.innerText
}